<template>
  <div class="bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
    <div class="max-w-7xl mx-auto">
      <!-- Section Title -->
      <div class="text-center mb-12">
        <h2 class="text-4xl font-bold text-gray-900">
          My Projects
        </h2>
        <p class="mt-3 text-lg text-gray-600 max-w-2xl mx-auto">
          A collection of applications I've built to solve problems and explore technologies
        </p>
      </div>

      <!-- Project Cards Grid -->
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        <div
          v-for="(project, index) in projects"
          :key="index"
          class="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300 border border-gray-100 flex flex-col"
        >
          <!-- Project Header with Icon -->
          <div class="p-5 pb-0 flex items-center space-x-3">
            <div class="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-lg bg-blue-50 text-blue-600">
              <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4"></path>
              </svg>
            </div>
            <h3 class="text-lg font-semibold text-gray-900">{{ project.title }}</h3>
          </div>

          <!-- Project Description -->
          <div class="p-5 pt-3 flex-grow">
            <p class="text-gray-600">{{ project.description }}</p>
          </div>

          <!-- View Button -->
          <div class="px-5 pb-5">
            <a
              :href="project.link"
              target="_blank"
              rel="noopener noreferrer"
              class="w-full inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200"
            >
              View Project
              <svg class="ml-2 -mr-1 w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clip-rule="evenodd"></path>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PortfolioPage',
  data() {
    return {
      projects: [
        {
          title: 'Quiz App',
          description: 'A quiz app where you answer questions and receive a total score.',
          link: 'https://quiz-app-eight-lovat.vercel.app/',
        },
        {
          title: 'Currency Converter',
          description: 'A web application to convert currencies between different countries.',
          link: 'https://currency-converter-app-azure.vercel.app/',
        },
        {
          title: 'Movie App',
          description: 'Watch all your favorite movies in one place with this streaming platform.',
          link: 'https://movie-app-pearl-xi.vercel.app/',
        },
        {
          title: 'Grocery Store',
          description: 'Do your grocery shopping online without visiting the store.',
          link: 'https://vervebridge.vercel.app/',
        },
        {
          title: 'School Website',
          description: 'A school website with information about programs, faculty, and admissions.',
          link: 'https://school-website-alpha-five.vercel.app/',
        },
        {
          title: 'Poultry Farm',
          description: 'A clean website for a poultry farm offering fresh eggs and premium poultry products.',
          link: 'https://empire-poultry.vercel.app/',
        },
        {
          title: 'Calculator',
          description: 'A simple and easy-to-use calculator for basic math operations.',
          link: 'https://calculator-app-sable-five.vercel.app/',
        },
        {
          title: 'News Search',
          description: 'Search and read the latest news articles from around the world.',
          link: 'https://news-search-app-1.vercel.app/',
        },
        {
          title: 'Image Search',
          description: 'Find and explore images from the web using keyword searches.',
          link: 'https://image-search-app-eaeu.vercel.app/',
        },
      ],
    };
  },
};
</script>
